import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Popover,
  Select,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import XLSX from "utils/xlsxStyled";
import eOpsLogo from "../../../images/eops.png";
import mepcoLogo from "../../../images/mepcoLogo.png";
import { cfpBaseUrl } from "../../../network/urls";
import { openJsPdfInNewTab, convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
  getShortMonthName,
  companyShortName,
  getCompanyName,
  companyName,
  getLogo,
} from "../../../services/Functions";
import "../../../style/common.scss";
import ReportExportButtons from "../../Report/components/ReportExportButtons";
import "../../Report/reportPageLayout.scss";
import "../../Report/ChangeOfAttributesStatusReport.scss";
import "./LinemanAPPUserSummary.scss";
import { resolveOfficeCodeForAdmin } from "../../../utils/adminCompany";
import useTechnicalReportLevel from "../../../hooks/useTechnicalReportLevel";
import ComplaintsReportLevelFields from "./components/ComplaintsReportLevelFields";

const LESCO_COMPANY_CODE = "11";
const DEFAULT_TAC_DESIGNATION_ID = "1135";
const LESCO_TAC_DESIGNATION_ID = "1177";
const TECHNICAL_DESIGNATION_IDS = [
  "95",
  "113",
  "1135",
  "1145",
  "1146",
  "1147",
  "1177",
];
const COMMERCIAL_DESIGNATION_IDS = [
  "94",
  "95",
  "96",
  "113",
  "114",
  "1114",
  "1131",
];

const LinemanAPPUserSummary = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const {
    token,
    code,
    name,
    roleName,
    roleTypeName,
    cscID,
    cfcLevelId,
    roleId,
    hierarchy: hierar, selectedAdminCompanyCode } = useSelector((state) => state.auth);
  const authCompanyCode = code.slice(0, 2);
  const isInitialLespco =
    String(code ?? "").slice(0, 2) === LESCO_COMPANY_CODE;

  const [isLoading, setIsLoading] = React.useState(false);
  // const { officeCode: offCode } = useSelector(state => state.officeCode);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");

  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCode(company);
    }
  }, [code, selectedAdminCompanyCode]);
  const [totals, setTotals] = useState({});
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const tableRef = useRef(null);
  const [dateFromDisplay, setDateFromDisplay] = useState("");
  const [dateToDisplay, setDateToDisplay] = useState("");
  const [category, setCategory] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRemarks, setSelectedRemarks] = useState("");
  const [selectedPerson, setSelectedPerson] = useState("");
  const [lastModifiedByOptions, setLastModifiedByOptions] = useState([]);
  const [selectedPerson1, setSelectedPerson1] = useState("");
  const [registeredByOptions, setRegisteredByOptions] = useState([]);
  const [desginationCodeToApi, setDesginationCodeToApi] = useState(() =>
    isInitialLespco ? LESCO_TAC_DESIGNATION_ID : DEFAULT_TAC_DESIGNATION_ID
  );
  const [desginationList, setDesginationList] = useState([]);
  const [companyCode, setCompanyCode] = useState("15");
  const [complaintPart, setComplaintPart] = useState("2");
  const [sourceWise, setSourceWise] = useState("2");
  const [shiftWise, setShiftWise] = useState("1");
  const [filteredDesignationList, setFilteredDesignationList] = useState([]);
  const [desginationName, setDesginationName] = useState(() =>
    isInitialLespco ? "Tac LESCO" : "TAC"
  );
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const offCode =
    hierar == 1
      ? code
      : hierar == 2
      ? code.slice(0, 2)
      : hierar == 3
      ? code.slice(0, 3)
      : hierar == 4
      ? code.slice(0, 4)
      : hierar == 5
      ? code.slice(0, 5)
      : code;
  const getEffectiveDiscoCode = () => {
    if (String(code) === "10" && selectedCompanyCode) {
      return String(selectedCompanyCode).slice(0, 2);
    }
    return String(authCompanyCode || code || "").slice(0, 2);
  };

  const isLespcoDisco = (discoCode = getEffectiveDiscoCode()) =>
    String(discoCode) === LESCO_COMPANY_CODE;

  const filterDesignationsByPart = (list, part) => {
    if (!Array.isArray(list)) return [];
    return list.filter((item) => {
      const id = item.employeeDesignationId.toString();
      if (part === "1") return COMMERCIAL_DESIGNATION_IDS.includes(id);
      if (part === "2") return TECHNICAL_DESIGNATION_IDS.includes(id);
      return true;
    });
  };

  const getDefaultTechnicalDesignation = (
    list,
    discoCode = getEffectiveDiscoCode()
  ) => {
    const defaultId = isLespcoDisco(discoCode)
      ? LESCO_TAC_DESIGNATION_ID
      : DEFAULT_TAC_DESIGNATION_ID;
    const match = (list || []).find(
      (item) => String(item.employeeDesignationId) === defaultId
    );
    return {
      id: defaultId,
      name:
        match?.employeeDesignationName ||
        (isLespcoDisco(discoCode) ? "Tac LESCO" : "TAC"),
    };
  };

  const applyDefaultDesignationForPart = (
    list,
    part,
    discoCode = getEffectiveDiscoCode()
  ) => {
    if (part === "1") {
      setDesginationCodeToApi("113");
      setDesginationName("TAC");
      return;
    }
    const { id, name } = getDefaultTechnicalDesignation(list, discoCode);
    setDesginationCodeToApi(id);
    setDesginationName(name);
  };

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  useEffect(() => {
    setOfficeCode(circleCode);
  }, [circleCode]);

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (complaintPart === "2") {
      const technicalFiltered = filterDesignationsByPart(desginationList, "2");
      applyDefaultDesignationForPart(
        technicalFiltered,
        "2",
        String(selectedCompany).slice(0, 2)
      );
    }

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let officeName = getName(
            String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(
          String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany =
              selectedCompanyCode || selectedAdminCompanyCode || offCode;
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const getStats = async (
    officeCode,
    roleId,
    sourceWise,
    shiftWise,
    complaintPart
  ) => {
    // const effectiveOfficeCode = selectedSubDivision || selectedDivision || circleCode || selectedCompanyCode || code.slice(0, 2);
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        officeCode: officeCode,
        roleId: roleId || "1135",
        isLoggedInFromMobile: sourceWise,
        shiftId: shiftWise,
        roleTypeId: complaintPart,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "workForce/getUserLoggedStatus",
        requestOptions
      );
      const result = await response.json();

      if (result.status == "200") {
        const data = result.data;

        const groupedData = {};

        data.forEach((user) => {
          const key = user.subDivisionCode;
          if (!groupedData[key]) {
            groupedData[key] = {
              circleCode: user.circleCode,
              circleName: user.circleName,
              divisionName: user.divisionName,
              subDivisionName: user.subDivisionName,
              roleName: user.role_id,
              sdivSet: new Set(),
              LoggedInLineStaff: 0,
              NeverLoggedInLineStaff: 0,
              totalLineStaff: 0,
            };
          }

          const group = groupedData[key];
          group.totalLineStaff += 1;
          if (user.isLogged_In) {
            group.LoggedInLineStaff += 1;
          } else {
            group.NeverLoggedInLineStaff += 1;
          }

          group.sdivSet.add(user.sdivCode);
        });

        const tableDataArray = Object.values(groupedData).map((group) => ({
          ...group,
          sdivCount: group.sdivSet.size,
        }));

        // 🔹 Check how many unique circles exist
        const uniqueCircles = [
          ...new Set(tableDataArray.map((item) => item.circleCode)),
        ];

        let finalData = [];

        if (uniqueCircles.length > 1) {
          // ✅ Case 1: Multiple circles → total by circle
          const circleTotals = {};
          tableDataArray.forEach((item) => {
            const circleKey = item.circleCode;
            if (!circleTotals[circleKey]) {
              circleTotals[circleKey] = {
                circleCode: circleKey,
                circleName: item.circleName,
                divisionName: "-",
                subDivisionName: "-",
                roleName: item.roleName,
                sdivCount: 0,
                LoggedInLineStaff: 0,
                NeverLoggedInLineStaff: 0,
                totalLineStaff: 0,
              };
            }
            circleTotals[circleKey].sdivCount += item.sdivCount;
            circleTotals[circleKey].LoggedInLineStaff += item.LoggedInLineStaff;
            circleTotals[circleKey].NeverLoggedInLineStaff +=
              item.NeverLoggedInLineStaff;
            circleTotals[circleKey].totalLineStaff += item.totalLineStaff;
          });

          const groupedByCircle = tableDataArray.reduce((acc, item) => {
            if (!acc[item.circleCode]) acc[item.circleCode] = [];
            acc[item.circleCode].push(item);
            return acc;
          }, {});

          Object.keys(groupedByCircle).forEach((circleCode) => {
            finalData.push(...groupedByCircle[circleCode]);
            finalData.push({ ...circleTotals[circleCode], isTotalRow: true });
          });
        } else {
          // ✅ Case 2: Only one circle → total by divisionName
          const divisionTotals = {};
          tableDataArray.forEach((item) => {
            const divKey = item.divisionName;
            if (!divisionTotals[divKey]) {
              divisionTotals[divKey] = {
                circleCode: item.circleCode,
                circleName: item.circleName,
                divisionName: divKey,
                subDivisionName: "-",
                roleName: item.roleName,
                sdivCount: 0,
                LoggedInLineStaff: 0,
                NeverLoggedInLineStaff: 0,
                totalLineStaff: 0,
              };
            }
            divisionTotals[divKey].sdivCount += item.sdivCount;
            divisionTotals[divKey].LoggedInLineStaff += item.LoggedInLineStaff;
            divisionTotals[divKey].NeverLoggedInLineStaff +=
              item.NeverLoggedInLineStaff;
            divisionTotals[divKey].totalLineStaff += item.totalLineStaff;
          });

          const groupedByDivision = tableDataArray.reduce((acc, item) => {
            if (!acc[item.divisionName]) acc[item.divisionName] = [];
            acc[item.divisionName].push(item);
            return acc;
          }, {});

          Object.keys(groupedByDivision).forEach((divName) => {
            finalData.push(...groupedByDivision[divName]);
            finalData.push({ ...divisionTotals[divName], isTotalRow: true });
          });
        }

        setTableData(finalData);
      } else if (result.status == "400") {
        setTableData([]);
      }
    } catch (error) {
      setTableData([]);
    }

    setViewBackdrop(false);
  };

  const exportToExcel = () => {
    let offName = officeName || "MEPCO Region";
    let dateToPrint = convertDate(new Date());

    const formattedDateFrom = dateFrom ? convertDate(dateFrom) : "-";
    const formattedDateTo = dateTo ? convertDate(dateTo) : "-";
    const headingText = `Active User Summary for ${companyShortName(
      code.slice(0, 2)
    )} of ${
      getDateDifference(dateFrom, dateTo) > 0
        ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
        : formatDate(dateFrom)
    }`;

    const wb = XLSX.utils.book_new();
    const wsData = [];

    wsData.push([headingText]);
    wsData.push([
      "Circle Code",
      "Circle Name",
      "Division Name",
      "Sub-Division Name",
      "Role Name",
      "LoggedIn User",
      "LoggedOut User",
      "Total User",
    ]);

    if (tableData && tableData.length > 0) {
      tableData.forEach((item) => {
        const role = desginationList.find(
          (designation) => designation.employeeDesignationId === item.roleName
        );
        wsData.push([
          item.circleCode || "-",
          item.circleName || "-",
          item.divisionName || "-",
          item.subDivisionName || "-",
          role?.employeeDesignationName || "-",
          item.LoggedInLineStaff || "-",
          item.NeverLoggedInLineStaff || "-",
          item.totalLineStaff || "-",
        ]);
      });

      const totalLoggedIn = tableData.reduce(
        (sum, item) => sum + (item.LoggedInLineStaff || 0),
        0
      );
      const totalNeverLoggedIn = tableData.reduce(
        (sum, item) => sum + (item.NeverLoggedInLineStaff || 0),
        0
      );
      const totalLineStaff = tableData.reduce(
        (sum, item) => sum + (item.totalLineStaff || 0),
        0
      );
      wsData.push([
        "Total",
        "",
        "",
        "",
        "",
        totalLoggedIn || "-",
        totalNeverLoggedIn || "-",
        totalLineStaff || "-",
      ]);
    } else {
      wsData.push(["No Data Found"]);
    }

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }];
    if (!ws["A1"]) ws["A1"] = {};
    ws["A1"].s = {
      alignment: { horizontal: "center", vertical: "center" },
      font: { bold: true },
    };

    [
      "Circle Code",
      "Circle Name",
      "Division Name",
      "Sub-Division Name",
      "Role Name",
      "LoggedIn User",
      "LoggedOut User",
      "Total User",
    ].forEach((_, index) => {
      const cell = XLSX.utils.encode_cell({ r: 1, c: index });
      if (!ws[cell]) ws[cell] = {};
      ws[cell].s = { font: { bold: true }, alignment: { horizontal: "left" } };
    });

    if (tableData && tableData.length > 0) {
      const totalRowIndex = tableData.length + 2;
      [
        "Circle Code",
        "Circle Name",
        "Division Name",
        "Sub-Division Name",
        "Role Name",
        "LoggedIn User",
        "LoggedOut User",
        "Total User",
      ].forEach((_, index) => {
        const cell = XLSX.utils.encode_cell({ r: totalRowIndex, c: index });
        if (!ws[cell]) ws[cell] = {};
        ws[cell].s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "FEF5C0" } },
          alignment: { horizontal: "left" },
        };
      });
    }

    ws["!cols"] = [
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 25 },
      { wch: 20 },
      { wch: 15 },
      { wch: 20 },
      { wch: 15 },
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const fileName = `${companyShortName(code.slice(0, 2))} - ${
      getDateDifference(dateFrom, dateTo) > 0
        ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
        : formatDate(dateFrom)
    } - lineman-app-usage-summary.xlsx`;

    saveAs(new Blob([wbout]), fileName);
  };

  const connectionTypes = [
    "Circle Code",
    "Circle Name",
    "Division Name",
    "Sub-Division Name",
    "Role Name",
    "LoggedIn User",
    "LoggedOut User",
    "Total User",
  ];

  const connectionTypesExcel = [
    "Circle Code",
    "Circle Name",
    "Division Name",
    "Sub-Division Name",
    "Role Name",
    "LoggedIn User",
    "LoggedOut User",
    "Total User",
  ];

  const [categoryName, setcategoryName] = useState("New Connections");

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);
      const title = `Active User Summary for ${offName} of ${
        getDateDifference(dateFrom, dateTo) > 0
          ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
          : formatDate(dateFrom)
      }`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode
      )
        ? 25
        : 30;
      const logoHeight = ["12", "13", "11", "16", "27", "48", "59"].includes(
        companyCode
      )
        ? 20
        : 10;
      pdf.addImage(
        getLogo(code.slice(0, 2)),
        "PNG",
        15,
        5,
        logoWidth,
        logoHeight
      );

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition = [
        "12",
        "13",
        "11",
        "16",
        "27",
        "48",
        "59",
      ].includes(companyCode)
        ? 43
        : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        ["12", "13", "11", "16", "27", "48", "59"].includes(companyCode)
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(12);
      pdf.text(companyName(code.slice(0, 2)), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `Active User Summary for ${companyShortName(code.slice(0, 2))}`,
        pageWidth / 2,
        18,
        { align: "center" }
      );
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        { content: "Circle Code", styles: { halign: "left" } },
        { content: "Circle Name", styles: { halign: "left" } },
        { content: "Division Name", styles: { halign: "left" } },
        { content: "Sub-Division Name", styles: { halign: "left" } },
        { content: "Role Name", styles: { halign: "left" } },
        { content: "LoggedIn User", styles: { halign: "left" } },
        { content: "LoggedOut User", styles: { halign: "left" } },
        { content: "Total User", styles: { halign: "left" } },
      ];

      let bodyData = [];

      if (tableData && tableData.length > 0) {
        // 🔹 Map table rows
        bodyData = tableData.map((item) => {
          const role = desginationList.find(
            (designation) => designation.employeeDesignationId === item.roleName
          );

          return [
            { content: item.circleCode || "-", styles: { halign: "left" } },
            { content: item.circleName || "-", styles: { halign: "left" } },
            { content: item.divisionName || "-", styles: { halign: "left" } },
            {
              content: item.subDivisionName || "-",
              styles: { halign: "left" },
            },
            {
              content:
                role?.employeeDesignationName ||
                (item.isTotalRow ? "TOTAL" : "-"),
              styles: { halign: "left" },
            },
            {
              content: item.LoggedInLineStaff || 0,
              styles: { halign: "left" },
            },
            {
              content: item.NeverLoggedInLineStaff || 0,
              styles: { halign: "left" },
            },
            { content: item.totalLineStaff || 0, styles: { halign: "left" } },
          ].map((cell) => {
            // 🔹 Style total rows differently
            if (item.isTotalRow) {
              return {
                ...cell,
                styles: {
                  ...cell.styles,
                  fontStyle: "bold",
                  fillColor: [233, 247, 239], // light green
                },
              };
            }
            return cell;
          });
        });

        // 🔹 Grand Total (only from isTotalRow)
        const totalRows = tableData.filter((item) => item.isTotalRow);

        const totalLoggedIn = totalRows.reduce(
          (sum, item) => sum + (item.LoggedInLineStaff || 0),
          0
        );
        const totalNeverLoggedIn = totalRows.reduce(
          (sum, item) => sum + (item.NeverLoggedInLineStaff || 0),
          0
        );
        const totalLineStaff = totalRows.reduce(
          (sum, item) => sum + (item.totalLineStaff || 0),
          0
        );

        // 🔹 Collect unique role names
        const uniqueRoles = [
          ...new Set(
            totalRows.map((item) => {
              const role = desginationList.find(
                (designation) =>
                  designation.employeeDesignationId === item.roleName
              );
              return role?.employeeDesignationName || "-";
            })
          ),
        ].join(", ");

        bodyData.push([
          {
            content: "Grand Total",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: "-",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: "-",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: "-",
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: uniqueRoles,
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: totalLoggedIn.toString(),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: totalNeverLoggedIn.toString(),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
          {
            content: totalLineStaff.toString(),
            styles: {
              halign: "left",
              fontStyle: "bold",
              fillColor: [254, 245, 192],
              textColor: [0, 0, 0],
            },
          },
        ]);
      } else {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: headers.length,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: {
          cellPadding: 3,
          fontSize: 8,
          halign: "left",
        },
        theme: "striped",
        tableWidth: pageWidth - 30,
        margin: { left: 15, right: 15 },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 50 },
          2: { cellWidth: 40 },
          3: { cellWidth: 50 },
          4: { cellWidth: 23 },
          5: { cellWidth: 31 },
          6: { cellWidth: 31 },
          7: { cellWidth: 20 },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      const filename = `${companyShortName(code.slice(0, 2))} - ${
        getDateDifference(dateFrom, dateTo) > 0
          ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
          : formatDate(dateFrom)
      } - lineman-app-usage-summary.pdf`;

      if (print) {
        openJsPdfInNewTab(pdf, filename);
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  // useEffect(() => {
  //   const getDesgination = async () => {
  //     setViewBackdrop(true);
  //     const myHeaders = new Headers();
  //     myHeaders.append("Authorization", token);
  //     const raw = "";
  //     const requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow"
  //     };
  //     fetch(cfpBaseUrl + "workForce/getListOfSubDivisionDesignations", requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         setViewBackdrop(false);
  //         if (result.message == 'Data Found.') {
  //           setDesginationList(result.data);
  //         }
  //       })
  //       .catch(() => {});
  //   };
  //   getDesgination();
  // }, [companyCode]);

  useEffect(() => {
    const getDesgination = async () => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: "",
        redirect: "follow",
      };
      try {
        const response = await fetch(
          cfpBaseUrl + "workForce/getListOfSubDivisionDesignations",
          requestOptions
        );
        const result = await response.json();
        setViewBackdrop(false);
        if (result.message === "Data Found.") {
          setDesginationList(result.data || []);
          const filtered = filterDesignationsByPart(
            result.data || [],
            complaintPart
          );
          setFilteredDesignationList(filtered);
          applyDefaultDesignationForPart(filtered, complaintPart);
        } else {
          setDesginationList([]);
          setFilteredDesignationList([]);
        }
      } catch (error) {
        setDesginationList([]);
        setFilteredDesignationList([]);
        setViewBackdrop(false);
      }
    };
    getDesgination();
  }, [token, complaintPart]);

  const getDateDifference = (startDate, endDate) => {
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];
    const start = new Date(startDates);
    const end = new Date(endDates);
    const differenceInTime = end - start;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
  };

  const handleRemarksClick = (event, remarks) => {
    if (remarks && remarks.trim() !== "") {
      setAnchorEl(event.currentTarget);
      setSelectedRemarks(remarks);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const handleChangeDesgination = (e) => {
    const selectedId = e.target.value;

    setDesginationCodeToApi(selectedId);
    const selectedObj = desginationList.find(
      (item) => item.employeeDesignationId.toString() === selectedId
    );
    if (selectedObj) {
      setDesginationName(selectedObj.employeeDesignationName); // <-- store name only
    }
  };
  const handlePart = (e) => {
    const selectedPart = e.target.value;
    setComplaintPart(selectedPart);
    if (selectedPart === "1") {
      const filtered = desginationList.filter(
        (item) => item.employeeDesignationId.toString() === "1135"
      );
      setFilteredDesignationList(filtered);
      setDesginationCodeToApi("1135");
      setDesginationName("TAC");
    } else {
      const filtered = filterDesignationsByPart(desginationList, "2");
      setFilteredDesignationList(filtered);
      applyDefaultDesignationForPart(filtered, "2");
    }
  };

  const handleSourceWise = (e) => {
    setSourceWise(e.target.value);
  };

  const handleShiftWise = (e) => {
    setShiftWise(e.target.value);
  };

  const {
    reportLevel,
    setAppliedReportLevel,
    availableReportLevelOptions,
    handleReportLevelChange,
    showCircleFilter,
    showDivisionFilter,
    showSubDivisionFilter,
    circleFilterEnabled,
    divisionFilterEnabled,
    subDivisionFilterEnabled,
    resolveApiOfficeCode,
  } = useTechnicalReportLevel({
    code,
    userHierarchy: hierar,
    cfcLevelId,
    hierarchy,
    offCode,
    subDivisions,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    officeCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    setCircleCode,
    setCircleName,
    setSelectedDivision,
    setSelectedSubDivision,
    setFilteredCircles,
    setFilteredDivisions,
    setFilteredSubDivisions,
    setOfficeCode,
    setOfficeName,
    getCompanies,
    getName,
  });

  const currentFilters = {
    officeCode,
    desginationCodeToApi,
    sourceWise,
    shiftWise,
    complaintPart,
    reportLevel,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [officeCode, desginationCodeToApi, sourceWise, shiftWise, complaintPart, reportLevel]);

  const handleGoClick = () => {
    const apiOfficeCode = resolveApiOfficeCode();
    setAppliedReportLevel(reportLevel);
    getStats(
      apiOfficeCode,
      desginationCodeToApi,
      sourceWise,
      shiftWise,
      complaintPart
    );

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };


  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      className="field-label"
      sx={{
        fontWeight: 600,
        display: "block",
      }}
    >
      {children}
    </Typography>
  );

  const tableCaptionText = `Active User Summary for ${officeName || getCompanies(code.slice(0, 2)) || ""} of ${
    getDateDifference(dateFrom, dateTo) > 0
      ? `${formatDate(dateFrom)} to ${formatDate(dateTo)}`
      : formatDate(dateFrom)
  }`;

  const getRowRoleName = (item) => {
    const role = desginationList.find(
      (designation) => designation.employeeDesignationId === item.roleName
    );
    return role?.employeeDesignationName || (item.isTotalRow ? "TOTAL" : "-");
  };

  const grandTotalRoleNames = [
    ...new Set(
      tableData
        .filter((item) => item.isTotalRow)
        .map((item) => getRowRoleName(item))
        .filter((name) => name && name !== "-")
    ),
  ].join(", ");

  const grandTotalLoggedIn = tableData
    .filter((item) => item.isTotalRow)
    .reduce((sum, item) => sum + (item.LoggedInLineStaff || 0), 0);

  const grandTotalLoggedOut = tableData
    .filter((item) => item.isTotalRow)
    .reduce((sum, item) => sum + (item.NeverLoggedInLineStaff || 0), 0);

  const grandTotalUsers = tableData
    .filter((item) => item.isTotalRow)
    .reduce((sum, item) => sum + (item.totalLineStaff || 0), 0);

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid container spacing={2} alignItems="flex-end">
      <ComplaintsReportLevelFields
        idPrefix="aus"
        code={code}
        reportLevel={reportLevel}
        onReportLevelChange={handleReportLevelChange}
        availableReportLevelOptions={availableReportLevelOptions}
        selectedCompanyCode={selectedCompanyCode}
        onChangeCompany={handleChangeCompany}
        showCircleFilter={showCircleFilter}
        circleCode={circleCode}
        onChangeCircle={handleCircleChange}
        filteredCircles={filteredCircles}
        circleFilterEnabled={circleFilterEnabled}
        showDivisionFilter={showDivisionFilter}
        selectedDivision={selectedDivision}
        onChangeDivision={handleDivisionChange}
        filteredDivisions={filteredDivisions}
        divisionFilterEnabled={divisionFilterEnabled}
        showSubDivisionFilter={showSubDivisionFilter}
        selectedSubDivision={selectedSubDivision}
        onChangeSubDivision={handleSubDivisionChange}
        filteredSubDivisions={filteredSubDivisions}
        subDivisionFilterEnabled={subDivisionFilterEnabled}
      />
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="aus-part">Part</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select id="aus-part" value={complaintPart} onChange={handlePart}>
              <MenuItem value="1">Commercial</MenuItem>
              <MenuItem value="2">Technical</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="aus-designation">Designation</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="aus-designation"
              value={desginationCodeToApi}
              onChange={handleChangeDesgination}
              disabled={!filteredDesignationList.length}
            >
              {filteredDesignationList.map((item, index) => (
                <MenuItem key={index} value={item.employeeDesignationId}>
                  {item.employeeDesignationName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="aus-source">Source</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select id="aus-source" value={sourceWise} onChange={handleSourceWise}>
              <MenuItem value="2">Both</MenuItem>
              <MenuItem value="0">Web</MenuItem>
              <MenuItem value="1">Mobile</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="aus-shift">Shift</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select id="aus-shift" value={shiftWise} onChange={handleShiftWise}>
              <MenuItem value="1">Morning</MenuItem>
              <MenuItem value="2">Evening</MenuItem>
              <MenuItem value="3">Night</MenuItem>
              <MenuItem value="4">Feeder Wise</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box
              aria-hidden
              sx={{
                height: "1.35rem",
                mb: 0.5,
                lineHeight: 1.35,
              }}
            />
            <Button
              id="aus-go-btn"
              fullWidth
              variant="contained"
              disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || viewBackdrop}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

  const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  return (
    <>
      <Box className="form-box rpt-page coa-status-report active-user-summary-page">
        <div className="coa-layout">
          <header className="coa-page-header">
            <h1 className="coa-page-title">Active User Summary</h1>
          </header>

          <div className="coa-toolbar-stack">
            <Paper
              variant="outlined"
              className="coa-card coa-card--filters"
              sx={{
                p: 2,
                width: "100%",
                bgcolor: "var(--eops-bg-form, #fff)",
                borderRadius: 2,
                borderColor: "divider",
              }}
            >
              <div
                className={
                  isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"
                }
              >
                {isMdUp ? (
                  renderFilters({ showGo: true })
                ) : (
                  <p className="coa-filters-hint">
                    Tap <strong>Filters</strong> to set office and options, then tap{" "}
                    <strong>GO</strong>.
                  </p>
                )}
              </div>

              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                spacing={1}
                className="coa-export-strip"
                sx={{
                  pt: 2,
                  mt: 2,
                  borderTop: "1px solid",
                  borderColor: "divider",
                  gap: 1,
                }}
              >
                {!isMdUp && (
                  <Tooltip title="Filters">
                    <IconButton
                      color="primary"
                      onClick={() => setMobileFilterOpen(true)}
                      aria-label="Open filters"
                      size="small"
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {!isMdUp && (
                  <Button
                    variant="contained"
                    disableElevation
                    className="coa-go-btn"
                    size="small"
                    onClick={handleGoClick}
                    disabled={isGoDisabled || viewBackdrop}
                  >
                    GO
                  </Button>
                )}
                <ReportExportButtons
                  isEmpty={tableData.length === 0}
                  onEmpty={noDataAvailable}
                  onPdf={() => DownloadPdf(true)}
                  onExcel={exportToExcel}
                  onPrint={printPDF}
                />
              </Stack>
            </Paper>
          </div>

          <div className="coa-report-banner" role="status">
            {tableCaptionText}
          </div>

          <Box
            className="application-table"
            sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
          >
            <div className="div-datagrid">
              <div className="coa-table-panel">
                <div className="coa-table-scroll" id="pdf-table">
                  <table className="coa-data-table table" ref={tableRef}>
                    <thead>
                      <tr>
                        {connectionTypes.map((type, index) => (
                          <th key={index} scope="col">
                            {type}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.length > 0 ? (
                        <>
                          {tableData.map((item, id) => (
                            <tr
                              key={id}
                              className={
                                item.isTotalRow ? "aus-circle-total-row" : undefined
                              }
                            >
                              <td>{item.circleCode || "-"}</td>
                              <td>{item.circleName || "-"}</td>
                              <td>{item.divisionName || "-"}</td>
                              <td>{item.subDivisionName || "-"}</td>
                              <td>{getRowRoleName(item)}</td>
                              <td>{item.LoggedInLineStaff || 0}</td>
                              <td>{item.NeverLoggedInLineStaff || 0}</td>
                              <td>{item.totalLineStaff || 0}</td>
                            </tr>
                          ))}
                          <tr className="aus-grand-total-row">
                            <td>Grand Total</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{grandTotalRoleNames || "-"}</td>
                            <td>{grandTotalLoggedIn}</td>
                            <td>{grandTotalLoggedOut}</td>
                            <td>{grandTotalUsers}</td>
                          </tr>
                        </>
                      ) : (
                        <tr className="coa-empty-row">
                          <td colSpan={connectionTypes.length}>No Data Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Box>

          <Drawer
            anchor="left"
            open={mobileFilterOpen}
            onClose={() => setMobileFilterOpen(false)}
            PaperProps={{
              className: "coa-filter-drawer",
              sx: {
                width: { xs: "100%", sm: 400 },
                maxWidth: "100vw",
                boxSizing: "border-box",
              },
            }}
          >
            <Box
              className="coa-drawer-inner"
              sx={{ p: 2, pb: 3, boxSizing: "border-box" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6" component="div">
                  Filters
                </Typography>
                <IconButton
                  aria-label="Close filters"
                  onClick={() => setMobileFilterOpen(false)}
                  edge="end"
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              {renderFilters({ showGo: true })}
            </Box>
          </Drawer>
        </div>
      </Box>
      {selectedRemarks && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableRestoreFocus
        >
          <div style={{ padding: "10px" }}>
            <Typography variant="h6" sx={{ fontSize: "17px" }}>
              Remarks :
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>{selectedRemarks}</Typography>
          </div>
        </Popover>
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>
    </>
  );
};

export default LinemanAPPUserSummary;
